import { SignPageBase } from '@xbcb/form-components';
import attribution from 'assets/attribution.txt';
import Docs from 'components/Docs';

const SignPage: React.FC<Record<string, never>> = () => (
  <SignPageBase attribution={attribution} Docs={Docs} />
);

export default SignPage;
